import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { Integration, Reminder, ReminderData } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(private http: HttpClient) { }

  getInegrations() {
    return this.http.get<Integration>(`${environment.baseUrl}` + apiConstant.INTEGRATIONS);
  }
}
